import React from "react";
import { Button, SelectBox, TagBox, DateBox } from "devextreme-react";
import { useAuth } from "../../context/authContext";
import { getDefaultLang } from "../../utils";

const dateRanges = [
  "today",
  "current week",
  "current month",
  "current year",
  "yesterday",
  "last week",
  "last month",
  "last year",
  "last 15 days",
  "last 30 days",
  "last 60 days",
  "last 90 days",
];

const FilterSelector = ({ formData, handleSubmit, onValueChanged }) => {
  const { activeLanguages, configParams, orderedWarehouses } = useAuth();

  const defaultAccountLang = getDefaultLang(
    configParams.default_language,
    activeLanguages
  );

  return (
    <div className="mt-4">
      <div className="">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-4 mb-3">
              <span className="sub-title text-capitalize">Start Date *</span>

              <DateBox
                type="date"
                showClearButton={true}
                pickerType="calendar"
                value={formData.startDate}
                onValueChanged={(e) => onValueChanged(e, "startDate")}
                displayFormat={"EEEE, dd MMM, yyyy"}
              />
            </div>
            <div className="col-4 mb-3">
              <span className="sub-title text-capitalize">End Date *</span>
              <DateBox
                type="date"
                showClearButton={true}
                pickerType="calendar"
                value={formData.endDate}
                onValueChanged={(e) => onValueChanged(e, "endDate")}
                displayFormat={"EEEE, dd MMM, yyyy"}
              />
            </div>
            <div className="col-4 mt-4">
              <SelectBox
                dataSource={dateRanges}
                showClearButton={true}
                searchEnabled={true}
                placeholder="date range selector"
                value={formData.dateRange}
                onValueChanged={(e) => onValueChanged(e, "dateRange")}
              />
            </div>
            <div className="col-6 mb-3">
              <span className="sub-title text-capitalize">Warehouses</span>
              <TagBox
                dataSource={orderedWarehouses}
                displayExpr={defaultAccountLang}
                valueExpr="id"
                placeholder="select warehouse"
                searchEnabled={true}
                showDropDownButton={true}
                showSelectionControls={true}
                selectAllMode="allPages"
                maxDisplayedTags={10}
                showClearButton={true}
                value={formData.warehouseIds}
                onValueChanged={(e) => onValueChanged(e, "warehouseIds")}
              />
            </div>
          </div>

          <Button
            useSubmitBehavior={true}
            className="mt-3"
            stylingMode="contained"
            type="default"
            text="Get report"
            elementAttr={{ style: "background-color: #0737a0" }}
          />
        </form>
      </div>
    </div>
  );
};

export default FilterSelector;
